import React from "react";
import { connect } from "react-redux";
import { Button } from "@vitalsource/vstui";
import { Tag } from "@vitalsource/vstui-icons";
import { Translation } from "../../../core/translate";
import { selectors as brandSelectors } from "../../../../redux/brand";

const FooterStoreButton = ({ enabled, url }) =>
  enabled ? (
    // TODO needs to sso
    <Button iconStart={<Tag />} naked href={url} target="_blank">
      <Translation id="global-bar.store">Store</Translation>
    </Button>
  ) : null;

const mapStateToProps = state => ({
  enabled: brandSelectors.getBrandValue(state, "Store.enabled", true),
  url: brandSelectors.getBrandValue(state, "Store.url", true)
});

export default connect(mapStateToProps)(FooterStoreButton);
